import { createAsyncThunk } from "@reduxjs/toolkit";
import {login , getUser} from './login-service';



export const getUserThunk = createAsyncThunk(
    'user',
    async () => await getUser()
)